import { CommercialUsageMetric } from '@repo/database/browser';
import { ERROR_KEYS } from '@repo/utils';

export const COMMERCIAL_LIMIT_EVENT = 'commercial-limit:exceeded';

export interface CommercialLimitEventDetail {
  metric: CommercialUsageMetric;
  limit: number;
}

export const resolveCommercialLimitEventDetail = (payload: {
  message?: string;
  params?: Record<string, string>;
}): CommercialLimitEventDetail | null => {
  if (payload.message !== ERROR_KEYS.COMMERCIAL_LIMITS.EXCEEDED) return null;
  const metric = payload.params?.metric as CommercialUsageMetric | undefined;
  if (!metric || !Object.values(CommercialUsageMetric).includes(metric)) {
    return null;
  }
  const limit = Number(payload.params?.limit ?? 0);
  return { metric, limit: Number.isFinite(limit) ? limit : 0 };
};

export const dispatchCommercialLimitEvent = (
  detail: CommercialLimitEventDetail
) =>
  window.dispatchEvent(
    new CustomEvent<CommercialLimitEventDetail>(COMMERCIAL_LIMIT_EVENT, {
      detail,
    })
  );
